import React, { memo } from 'react'
import { AnimatedIcon } from '@node-space/storybook-components/dist/AnimatedIcon'
import loader from '@node-space/storybook-components/dist/lottie/loader.json'
import { Box } from '@node-space/ui-components'
import { useThemeContext } from 'hooks/context/useThemeContext'
import { LogoColor } from 'types/types'
import { Logo } from './logos/Logo'

const AppLoader = () => {
  const { darkMode } = useThemeContext()

  return (
    <Box
      flex
      flexCol
      centerChildren
      width="full"
      minHeight="screen"
      gap={20}
      className="bg-surface-flat"
    >
      <AnimatedIcon animationData={loader} width={80} height={80} />
      <Logo logoColor={darkMode ? LogoColor.LIGHT : LogoColor.DARK} />
    </Box>
  )
}

export default memo(AppLoader)
